var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThirdCandyland(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.0619 21.7267L50.8192 10.6971C51.3433 8.6005 53.8661 7.53409 55.5858 8.84286C55.7047 8.93333 55.8189 9.03303 55.9276 9.14165C56.5791 9.79319 56.905 10.6472 56.9051 11.5013C56.905 12.2238 57.6094 12.743 58.3215 12.6214C59.6959 12.3868 61.1592 12.8 62.2201 13.8609C63.281 14.9218 63.6942 16.3851 63.4597 17.7596C63.3381 18.4717 63.8573 19.1762 64.5798 19.1761C65.4339 19.1761 66.2879 19.502 66.9395 20.1536C67.0481 20.2622 67.1478 20.3764 67.2382 20.4952C68.547 22.215 67.4805 24.7377 65.384 25.2619L54.3544 28.0193",
    fill: "#C16628"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0619 21.7267L50.8192 10.6971C51.3433 8.6005 53.8661 7.53409 55.5858 8.84286C55.7047 8.93333 55.8189 9.03303 55.9276 9.14165C56.5791 9.79319 56.905 10.6472 56.9051 11.5013C56.905 12.2238 57.6094 12.743 58.3215 12.6214C59.6959 12.3868 61.1592 12.8 62.2201 13.8609C63.281 14.9218 63.6942 16.3851 63.4597 17.7596C63.3381 18.4717 63.8573 19.1762 64.5798 19.1761C65.4339 19.1761 66.2879 19.502 66.9395 20.1536C67.0481 20.2622 67.1478 20.3764 67.2382 20.4952C68.547 22.215 67.4805 24.7377 65.384 25.2619L54.3544 28.0193",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6109 54.7621L24.8536 65.7917C24.3295 67.8883 21.8067 68.9547 20.087 67.6459C19.9681 67.5554 19.8539 67.4557 19.7452 67.3471C19.0937 66.6956 18.7678 65.8416 18.7677 64.9874C18.7678 64.265 18.0634 63.7458 17.3513 63.8674C15.9769 64.102 14.5136 63.6888 13.4527 62.6279C12.3918 61.5669 11.9786 60.1036 12.2131 58.7291C12.3346 58.017 11.8155 57.3126 11.093 57.3127C10.2389 57.3127 9.38486 56.9867 8.73332 56.3352C8.62469 56.2266 8.525 56.1124 8.43463 55.9935C7.12576 54.2737 8.19226 51.7511 10.2888 51.2269L21.3184 48.4695",
    fill: "#C16628"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6109 54.7621L24.8536 65.7917C24.3295 67.8883 21.8067 68.9547 20.087 67.6459C19.9681 67.5554 19.8539 67.4557 19.7452 67.3471C19.0937 66.6956 18.7678 65.8416 18.7677 64.9874C18.7678 64.265 18.0634 63.7458 17.3513 63.8674C15.9769 64.102 14.5136 63.6888 13.4527 62.6279C12.3918 61.5669 11.9786 60.1036 12.2131 58.7291C12.3346 58.017 11.8155 57.3126 11.093 57.3127C10.2389 57.3127 9.38486 56.9867 8.73332 56.3352C8.62469 56.2266 8.525 56.1124 8.43463 55.9935C7.12576 54.2737 8.19226 51.7511 10.2888 51.2269L21.3184 48.4695",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2082 24.8731C58.5932 32.2581 58.5932 44.2315 51.2082 51.6165C43.8232 59.0016 31.8497 59.0016 24.4647 51.6166C17.0798 44.2316 17.0798 32.2582 24.4648 24.8731C31.8498 17.4881 43.8232 17.4881 51.2082 24.8731Z",
    fill: "#C16628",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2848 50.4364L15.8124 55.5492L23.2848 50.4364Z",
    fill: "#C16628"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2848 50.4364L15.8124 55.5492",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5317 60.2681L25.6444 52.7957L20.5317 60.2681Z",
    fill: "#C16628"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5317 60.2681L25.6444 52.7957",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3879 26.0526L59.8603 20.9399L52.3879 26.0526Z",
    fill: "#C16628"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3879 26.0526L59.8603 20.9399",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M55.141 16.2205L50.0283 23.6929L55.141 16.2205Z",
    fill: "#C16628"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M55.141 16.2205L50.0283 23.6929",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8267 45.8149C22.8739 43.7677 21.3008 42.1946 23.3482 40.1472C23.7362 39.7592 24.1071 39.5012 24.4674 39.324",
    fill: "#C16628"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8267 45.8149C22.8739 43.7677 21.3008 42.1946 23.3482 40.1472C23.7362 39.7592 24.1071 39.5012 24.4674 39.324",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6483 37.541C53.6956 35.4938 52.1225 33.9206 54.1698 31.8733C54.5578 31.4853 54.9287 31.2273 55.289 31.05",
    fill: "#C16628"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6483 37.541C53.6956 35.4938 52.1225 33.9206 54.1698 31.8733C54.5578 31.4853 54.9287 31.2273 55.289 31.05",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6692 43.6525L33.1812 41.8045C34.2132 43.0045 35.9172 43.7485 37.6212 43.7485C39.7332 43.7485 40.9572 42.7885 40.9572 41.3005C40.9572 39.7165 39.6852 39.0445 37.4052 39.0445C36.7332 39.0445 35.7972 39.0445 35.5572 39.0685V36.5485C35.8452 36.5725 36.7812 36.5725 37.4052 36.5725C39.2772 36.5725 40.6932 35.9245 40.6932 34.4605C40.6932 32.9725 39.2532 32.2045 37.4532 32.2045C35.8212 32.2045 34.4772 32.8285 33.3252 33.9805L31.8852 32.2285C33.1092 30.7885 35.0532 29.7085 37.7172 29.7085C41.1732 29.7085 43.5012 31.3405 43.5012 34.0285C43.5012 36.1645 41.6772 37.4125 40.0212 37.7005C41.5812 37.8445 43.7412 39.1165 43.7412 41.5885C43.7412 44.3005 41.4132 46.2445 37.7172 46.2445C34.8612 46.2445 32.7492 45.0925 31.6692 43.6525Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThirdCandyland);
export default __webpack_public_path__ + "static/media/thirdCandyland.bfe99eac99cf64d3ced64b8ed278a2ad.svg";
export { ForwardRef as ReactComponent };